const getLinkBannerUrl = (linkUrl: string): any => {
  const url = typeof window !== 'undefined' ? new URL(window.location.href) : null

  return linkUrl?.replace('https://www.pharmedistore.com', url?.origin)
}
export { getLinkBannerUrl }
